import api from "./api";

// Capa de servicios API del dominio "whatsapp" (conexiones) (FSD / capa API transversal).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Listado / lectura ---
export const listWhatsapps = (params) => api.get("/whatsapp", { params });
export const getWhatsapp = (whatsAppId, params) =>
  api.get(`/whatsapp/${whatsAppId}`, { params });
export const getWhatsappDeletePreview = (whatsAppId) =>
  api.get(`/whatsapp/${whatsAppId}/delete-preview`);

// --- CRUD ---
export const createWhatsapp = (payload) => api.post("/whatsapp", payload);
export const updateWhatsapp = (whatsAppId, payload) =>
  api.put(`/whatsapp/${whatsAppId}`, payload);
export const deleteWhatsapp = (whatsAppId) => api.delete(`/whatsapp/${whatsAppId}`);

// --- Cambios de configuración (preview / apply) ---
export const previewWhatsappChange = (whatsAppId, payload) =>
  api.post(`/whatsapp/${whatsAppId}/preview-change`, payload);
export const applyWhatsappChange = (whatsAppId, payload) =>
  api.post(`/whatsapp/${whatsAppId}/apply-change`, payload);

// --- Control de sesión ---
export const startWhatsappSession = (whatsAppId) =>
  api.post(`/whatsappsession/${whatsAppId}`);
export const cleanWhatsappSession = (whatsAppId) =>
  api.post(`/whatsapp/${whatsAppId}/clean-session`);
export const restartWhatsapp = (whatsAppId) =>
  api.post(`/whatsapp/${whatsAppId}/restart`);
